import * as React from 'react';
import * as DTO from '../../service/DTOs';
import * as Session from '../../service/Session';
import { AppState } from '../../service/AppState';


type QuotesInformerProps = { marketquotes?: DTO.MarketQuotes} & { xsrfToken?: string };


export class QuotesInformer extends React.Component<QuotesInformerProps> {
    constructor(props: QuotesInformerProps) {
        super(props);
    }

    public render() {

        if (!this.props.marketquotes || !this.props.marketquotes.forexquotes)
            return <span></span>
        else {

            const fxSet = this.props.marketquotes.forexquotes.map((quote, idx) => {
                let symbol = (quote.basecur == 'XAU' && quote.quotecur == 'USD') ? 'GOLD'
                    : ((quote.basecur == 'XAG' && quote.quotecur == 'USD') ? 'SILVER' : ('' + quote.basecur + quote.quotecur));

                return <span key={'quote' + idx} className='quote-item'>
                    <span className='quote-symbol'>{symbol}</span>{' '}<span className={'quote-price-' + quote.bidchange}>{quote.bid}</span>/<span className={'quote-price-' + quote.askchange}>{quote.ask}</span>
                </span>
                }
            );

            return <div className='informer-quotes'>
                <div className='scroll-left'>
                    {fxSet}
                </div>
            </div>
        }
    }
}
